<template lang="pug">
  .component
    .container.page
      .row
        .col-xs-12.col-lg-10.offset-lg-1
          content-block(:transparent="false")
            h1 Page not found
            p We couldn't find the page you requested.
            p If you feel something is missing that should be here,
              | &nbsp;
              router-link(to="/form/zxJAoZ") contact
              |  us.


</template>

<script>
export default {
  name: 'FourOFourPage'
}
</script>
